import { getPlatformIdentity, loginPlatform } from "../../../features/platform-admin/platformAdminApi.ts";
import { agencyContext } from "./agencyIdentityService.ts";


export type IdentityContext = {
  accountKind: "platform" | "customer";
  isAuthenticated: boolean;
  csrfToken: string;
};

export async function getIdentityContext(): Promise<IdentityContext> {
  return getPlatformIdentity();
}

export async function loginIdentity(userName: string, password: string, csrfToken: string): Promise<{
  accountKind: "platform" | "customer";
  token?: string;
}> {
  return loginPlatform(userName, password, csrfToken);
}

export function normalizeLoginDigits(value: string = ""): string {
  return value.trim().replace(/[۰-۹٠-٩]/g, (digit) => {
    const code = digit.charCodeAt(0);
    return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
  });
}

export async function getCustomerProfile(): Promise<any> {
  const context = await agencyContext();
  return { ...context, fullName: context.displayName, phoneNumber: context.mobile, userName: context.userName || context.mobile || context.email,
    agencyTitle: context.agencyTitle };
}
